import React from 'react';
import {ExternalLink, Globe, Mail} from 'lucide-react';
import {Link} from 'react-router-dom';

const footerLinks = [
    {label: 'Usługi', href: '/#uslugi'},
    {label: 'Cennik', href: '/#cennik'},
    {label: 'Wykonania', href: '/wykonania'},
    {label: 'Kalkulator', href: '/kalkulator'},
    {label: 'Blokada reklam WiFi', href: '/blokada-reklam'},
    {label: 'Bezpłatna wycena', href: '/wycena'},
    {label: 'Kontakt', href: '/kontakt'},
    {label: 'Polityka prywatności', href: '/polityka-prywatnosci'},
];

const socialLinks = [
    {icon: <Globe size={18}/>, href: 'https://kamerymielec.pl', label: 'Strona kamerymielec.pl'},
    {icon: <ExternalLink size={18}/>, href: 'https://onexo.pl', label: 'Grupa ONEXO'},
    {icon: <Mail size={18}/>, href: 'mailto:kontakt@kamerymielec.pl', label: 'Email kontaktowy'},
];

export function Footer() {
    return (
        <footer className="w-full border-t border-border bg-background">
            <div className="max-w-5xl mx-auto px-5 py-10">
                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 mb-8">
                    <div className="flex flex-col gap-3">
                        <p className="text-xs text-muted-foreground max-w-sm leading-relaxed">
                            <strong className="text-foreground">Monitoring Mielec - kamerymielec.pl</strong><br/>
                            Montaż kamer, monitoring CCTV 4K, systemy alarmowe, wideodomofony, anty-reklama Wi-Fi i&nbsp;usługi IT w&nbsp;Mielcu (39-300) oraz w całym regionie w promieniu do 250 km. Bezpłatna wycena, szybki montaż i gwarancja.
                        </p>
                    </div>
                    <div className="flex flex-wrap gap-x-6 gap-y-2">
                        {footerLinks.map((link) =>
                            link.href.startsWith('/') ? (
                                <Link
                                    key={link.href}
                                    to={link.href}
                                    className="text-xs text-muted-foreground hover:text-foreground transition-colors"
                                >
                                    {link.label}
                                </Link>
                            ) : (
                                <a
                                    key={link.href}
                                    href={link.href.replace('/', '')}
                                    className="text-xs text-muted-foreground hover:text-foreground transition-colors"
                                >
                                    {link.label}
                                </a>
                            )
                        )}
                    </div>
                </div>

                <div className="rounded-2xl border border-border bg-muted/40 px-5 py-4 mb-6">
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
                        <p className="text-xs text-muted-foreground text-center sm:text-left">
                            <span className="font-semibold text-foreground">Kamery Mielec</span> to marka należąca do
                            grupy{' '}
                            <a
                                href="https://onexo.pl"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary hover:underline font-semibold"
                            >
                                ONEXO Group
                            </a>
                            {' '}- monitoring wizyjny, zabezpieczenia i&nbsp;infrastruktura IT w Mielcu i promień do 250 km.
                        </p>
                        <a
                            href="https://onexo.pl"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="shrink-0 inline-flex items-center gap-1.5 rounded-full border border-primary/30 bg-primary/10 px-3 py-1.5 text-xs font-semibold text-primary hover:bg-primary/20 transition-colors"
                        >
                            Poznaj ONEXO
                            <ExternalLink size={13}/>
                        </a>
                    </div>
                </div>

                <div
                    className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-border">
                    <p className="text-xs text-muted-foreground text-center sm:text-left">
                        &copy; {new Date().getFullYear()} Kamery Mielec (kamerymielec.pl). Wszelkie prawa zastrzeżone.
                    </p>
                    <div className="flex gap-1">
                        {socialLinks.map((social) => (
                            <a
                                key={social.label}
                                href={social.href}
                                aria-label={social.label}
                                className="w-8 h-8 flex items-center justify-center rounded-full text-muted-foreground hover:text-foreground hover:bg-muted transition"
                            >
                                {social.icon}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
}